// Importing the CSS file for styling the feedback page.
import '../FeedbackPage.css';

// Importing Navbar, FeedbackPageHeader, and FeedbackForm components.
import NavBar from './Navbar';
import FeedbackPageHeader from './FeedbackPageHeader';
import FeedbackForm from './FeedbackForm';
import { Container } from 'react-bootstrap';

// FeedbackPage component: Combines Navbar, FeedbackPageHeader, and FeedbackForm
// components to create the feedback page.
function FeedbackPage() {
    return (
        <div>
            {/* Render the Navbar component. */}
            <NavBar />
            <div className="app-page-shell">
            <Container className="feedback-container">
                {/* Render the FeedbackPageHeader component. */}
                <FeedbackPageHeader />
                <FeedbackForm />
            </Container>
            </div>
        </div>
    );
}

// Exporting the FeedbackPage component so it can be imported and used in other
// parts of the app.
export default FeedbackPage;
